import {
  Component, OnInit, Inject, Injector,
  forwardRef, ElementRef, NgZone,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { OFormComponent } from './o-form.component';
import { InputConverter } from '../../decorators';
import { Util } from '../../util/util';
import { DialogService, NavigationService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_FORM_TOOLBAR = [
  'labelHeader: label-header',
  'labelHeaderAlign: label-header-align',
  'headeractions: header-actions',
  'showHeaderActionsText: show-header-actions-text'
];



export class OFormToolbarComponent implements OnInit {

  public static DEFAULT_INPUTS_O_FORM_TOOLBAR = DEFAULT_INPUTS_O_FORM_TOOLBAR;

  /* Bindings */
  labelHeader: string = '';
  headeractions: string = '';
  labelHeaderAlign: string = 'center';
  @InputConverter()
  showHeaderActionsText: boolean = true;

  formActions: string[];
  isDetail: boolean = true;

  public editMode: boolean = false;
  public insertMode: boolean = false;
  public initialMode: boolean = true;

  protected refreshBtnEnabled: boolean = false;
  protected insertBtnEnabled: boolean = false;
  protected editBtnEnabled: boolean = false;
  protected deleteBtnEnabled: boolean = false;
  protected navigationEnabled: boolean = false;


  protected _dialogService: DialogService;
  protected _navigationService: NavigationService;

  constructor(  private _form: OFormComponent,
    public element: ElementRef,
    private _router: Router,
    private _actRoute: ActivatedRoute,
    private zone: NgZone,
    protected injector: Injector) {
    _form.registerToolbar(this);
    this._dialogService = this.injector.get(DialogService);
    this._navigationService = this.injector.get(NavigationService);
  }

  ngOnInit() {
    this.formActions = Util.parseArray(this.headeractions);
    if (this.formActions && this.formActions.length > 0) {
      this.refreshBtnEnabled = this.formActions.indexOf('R') !== -1;
      this.insertBtnEnabled = this.formActions.indexOf('I') !== -1;
      this.editBtnEnabled = this.formActions.indexOf('U') !== -1;
      this.deleteBtnEnabled = this.formActions.indexOf('D') !== -1;
    }
    if (this._navigationService) {
      var self = this;
      this._navigationService.onTitleChange(title => {
        self.labelHeader = title;
      });
    }
  }

  public setInitialMode() {
    this.initialMode = true;
    this.insertMode = false;
    this.editMode = false;
  }

  public setInsertMode() {
    this.insertMode = true;
    this.editMode = false;
    this.initialMode = false;
  }

  public setEditMode() {
    this.editMode = true;
    this.insertMode = false;
    this.initialMode = false;
  }

  onCloseDetail() {
    this._form.executeToolbarAction(OFormComponent.CLOSE_DETAIL_ACTION);
  }

  onBack() {
    this._form.executeToolbarAction(OFormComponent.BACK_ACTION);
  }

  onReload() {
    this._form.executeToolbarAction(OFormComponent.RELOAD_ACTION);
  }

  onInsert() {
    this.setInsertMode();
    this._form.executeToolbarAction(OFormComponent.GO_INSERT_ACTION);
  }

  onEdit() {
    this.setEditMode();
    this._form.executeToolbarAction(OFormComponent.GO_EDIT_ACTION);
  }

  onDelete(evt: any) {
    this.showConfirmDelete(evt);
  }

  cancelOperation() {
    if (this.isDetail) {
      this.onCloseDetail();
    } else if (!this.isDetail && this.insertMode) {
      this.onCloseDetail();
    } else {
      this.onReload();
    }
    this.setInitialMode();
  }

  acceptOperation() {

    if (this.editMode) {
      this.handleAcceptEditOperation();
    } else if (this.insertMode) {
      this.handleAcceptInsertOperation();
    }
  }

  handleAcceptInsertOperation() {
    this._form.executeToolbarAction(OFormComponent.INSERT_ACTION);
  }

  handleAcceptEditOperation() {
    this._form.executeToolbarAction(OFormComponent.EDIT_ACTION);
  }

  showConfirmDelete(evt: any) {
    this._dialogService.confirm('CONFIRM', 'MESSAGES.CONFIRM_DELETE')
      .then(
      res => {
        if (res === true) {
          this._form.executeToolbarAction(OFormComponent.DELETE_ACTION)
            .subscribe(resp => {
              //TODO mostrar un toast indicando que la operación fue correcta...
              this.onCloseDetail();
            }, err => {
              alert('Se ha producido un error!');
            });
        }
      }
      );
  }

  next() {
    //TODO
    // let total = this._form.navigationData.length;
    // let index = this._form.currentIndex + 1;
    // if (total > index) {
    //   this._form.move(index);
    // } else {
    //   console.log('form-toolbar->next(): total > index');
    // }
  }

  previous() {
    //TODO
    // let index = this._form.currentIndex - 1;
    // if (index >= 0) {
    //   this._form.move(index);
    // } else {
    //   console.log('form-toolbar->next(): index < 0');
    // }
  }

  first() {
    //TODO
    // this._form.move(0);
  }

  last() {
    //TODO
    // let index = this._form.navigationData.length - 1;
    // this._form.move(index);
  }

  numberOfRecords() {
    if (this.navigationEnabled) {
      let total = this._form.navigationData.length;
      let index = this._form.currentIndex + 1;
      if (total === 0 || total === 1) {
        return '';
      }
      return index + ' / ' + total;
    }
    return '';
  }

  showNavigation() {
    //navigationEnabled
    if (this.navigationEnabled) {
      return this._form.navigationData.length >= 1;
    }
    return false;
  }

  getLabelHeaderAlign(): string {
    return this.labelHeaderAlign;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-form-toolbar',
  template: `
    <md-toolbar class="toolbar-form-header">

      <div class="mat-toolbar-tools" fxFill *ngIf="initialMode">
        <md-icon aria-label="Back" (click)="onCloseDetail()" *ngIf="isDetail">arrow_back</md-icon>

        <md-icon aria-label="First" (click)="first()" *ngIf="showNavigation()" layout-padding>first_page</md-icon>
        <md-icon aria-label="Previous" (click)="previous()" *ngIf="showNavigation()" layout-padding>keyboard_arrow_left</md-icon>
        <span>{{numberOfRecords()}}</span>
        <md-icon aria-label="Next" (click)="next()" *ngIf="showNavigation()" layout-padding>keyboard_arrow_right</md-icon>
        <md-icon aria-label="Last" (click)="last()" *ngIf="showNavigation()" layout-padding>last_page</md-icon>

        <span *ngIf="getLabelHeaderAlign() === 'center' || getLabelHeaderAlign() === 'end'" class="fill-remaining"></span>
        <div *ngIf="labelheader!=''" fxLayout="row" fxLayoutAlign="center center">
          <span>{{ labelHeader | oTranslate }}</span>
        </div>
        <span *ngIf="getLabelHeaderAlign() === 'start' || getLabelHeaderAlign() === 'center'" class="fill-remaining"></span>

        <ng-content select="[o-custom-form-toolbar-buttons-wrapper]"></ng-content>

        <button md-button (click)="onReload($event)" *ngIf="refreshBtnEnabled">
          <md-icon>autorenew</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'REFRESH' | oTranslate }}</span>
        </button>
        <button md-button (click)="onInsert($event)" *ngIf="insertBtnEnabled">
          <md-icon>add</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'ADD' | oTranslate }}</span>
        </button>
        <button md-button (click)="onEdit($event)" *ngIf="editBtnEnabled">
          <md-icon>mode_edit</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'EDIT' | oTranslate }}</span>
        </button>
        <button md-button (click)="onDelete($event)" *ngIf="deleteBtnEnabled">
          <md-icon>delete</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'DELETE' | oTranslate }}</span>
        </button>
      </div>

      <div class="mat-toolbar-tools" fxFill *ngIf="editMode || insertMode">
        <span class="fill-remaining"></span>
        <button md-button (click)="cancelOperation($event)">
          <md-icon>clear</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'CANCEL' | oTranslate }}</span>
        </button>
        <button md-button color="primary" (click)="acceptOperation($event)">
          <md-icon>done</md-icon>
          <span *ngIf="showHeaderActionsText">{{ 'OK' | oTranslate }}</span>
        </button>
      </div>

    </md-toolbar>
  `,
  styles: [`
    .toolbar-form-header{min-height:50px}.toolbar-form-header md-toolbar-row{height:50px}.toolbar-form-header .mat-toolbar-tools{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;box-sizing:border-box;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.toolbar-form-header .mat-toolbar-tools .fill-remaining{flex:1 1 auto}.toolbar-form-header .mat-toolbar-tools button{min-width:100px;padding:0px 6px}.toolbar-form-header .mat-toolbar-tools md-icon{cursor:pointer;vertical-align:middle}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_FORM_TOOLBAR
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Router, },
{type: ActivatedRoute, },
{type: NgZone, },
{type: Injector, },
];
}


export class OFormToolbarModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OFormToolbarComponent],
  imports: [OSharedModule, CommonModule ],
  exports: [OFormToolbarComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
